import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const { t: $t } = useI18n()
const year = computed(() => new Date().getFullYear())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", null, _toDisplayString(_unref($t)('footer.copyright', { year: year.value })), 1))
}
}

})